import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ComponentsModule } from "@components/components.module";
import { environment } from "@environments/environment";
import { EffectsModule } from "@ngrx/effects";
import { StoreRouterConnectingModule } from "@ngrx/router-store";
import { StoreModule } from "@ngrx/store";
import { provideEnvironmentNgxMask } from "ngx-mask";
import { JwtLocalApiInterceptor } from "./interceptors/jwt-local-api.interceptor";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { metaReducers, reducers } from "./state";
import { AppEffects } from "./state/effects/app.effects";
import { UserEffects } from "./state/effects/user.effects";

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ComponentsModule,
    StoreModule.forRoot(reducers, { metaReducers }),
    ...environment.imports,
    StoreRouterConnectingModule.forRoot(),
    EffectsModule.forRoot([UserEffects, AppEffects]),
    HttpClientModule
  ],
  providers: [
    provideEnvironmentNgxMask({
      thousandSeparator: ".",
      decimalMarker: ",",
      dropSpecialCharacters: true
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtLocalApiInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
